import React, { Component } from 'react';
import style from './Footer.module.css';

class Footer extends Component {
  render() {
    return (
      <footer className={style.footer}>
        <p>※掲載している情報は掲載時点のものです。</p>
        <p>&copy; Tokyo City Univ. Jr & Sr High School. All rights reserved</p>
      </footer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/components/common/Footer.js